/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../Fct/createPlugin';
import { FctJSON, } from '../../../Fct/generics';
export var GetJSON = createPlugin({
    protocol: 'FUNCTIONS',
    type: 'GETTER',
    method: 'getJSON',
    name: 'getJSON',
    flowType: 'OFFCHAIN_ONLY',
    getParams: function () { return ({
        input: {
            JSON: new FctJSON({ required: true }),
            methodParams: {},
        },
        output: {},
    }); },
});
